(function($) {
  var el = '[data-toggle=spinner]';
  
  $(document).on('click', el, function(event) {
    var
      DATA = $(this).data(),
      target = DATA.target,
      control = DATA.control;

    var
      val = $(target).val(),
      min = Number($(target).attr('min')),
      max = Number($(target).attr('max'));

    var newVal = val;

    switch(control) {
      case 'increase':
        if (val < max) {
          newVal = ++val;
        }
        break;
      case 'decrease':
        if (val > min) {
          newVal = --val;
        }
        break;
    }

    $(target).val(newVal);
  });
})(jQuery);